import {Component, OnInit} from '@angular/core';
import {RegistryService} from "../../../../services/registry.service";
import {CartService} from "../../../../services/cart.service";
import {Cart} from "../../../../models/CartModels/cart";

import {CartItem} from "../../../../models/CartModels/cartItem";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-currency-icon',
    templateUrl: './currency-icon.component.html',
    styleUrls: ['./currency-icon.component.css']
})
export class CurrencyIconComponent implements OnInit {


    products_count = 0;
    cart: Cart;
    baseImageUrl;
    sum = 0;

    lang = 'en-US';

    currency_codes = [];
    selected_currency = "USD";


    constructor(private registry: RegistryService,
                private cartService: CartService,
                public translate: TranslateService
    ) {

        this.registry.CurrencyLoadedEvent$.subscribe( currency =>{

            this.currency_codes = currency?.available_currency_codes;
        //    this.registry.current_currency = currency.default_display_currency_code;
            this.selected_currency = this.registry.current_currency;

        })

        // this.registry.CurrencyLoadedEvent$.subscribe(data => {
        //
        //
        //     console.log(this.currency_codes);
        //
        // });


    }

    ngOnInit(): void {

        this.lang = this.cartService.getCurrentLang();
        this.currency_codes = this.registry.currency_data?.available_currency_codes;
        this.selected_currency = this.registry.current_currency;

    }

    currencyChanged($event, value) {

        this.registry.current_currency = value;
        this.selected_currency = value;
        this.registry.EmitCurrencyChangedEvent(value);

    }

    removeSearchBarValue(event) {
        if (event != null) {
            event.preventDefault();
        }
        localStorage.setItem('searchKeyword', '');
    }


}
